export const PrivacyCookieEvent = {
  CookiePolicyView: 'account_cookie_policy_view',
  CookieAcceptReqClick: 'account_cookie_acceptreq_click',
  CookieAcceptAllClick: 'account_cookie_acceptall_click',
} as const;

export interface PrivacyCookieEventDataType {
  [PrivacyCookieEvent.CookiePolicyView]: {};
  [PrivacyCookieEvent.CookieAcceptReqClick]: {};
  [PrivacyCookieEvent.CookieAcceptAllClick]: {};
}
